import { Box, Typography } from '@mui/material';
import {
  getTranscriptionLineTags,
  NO_TRANSCRIPTION_MESSAGE,
} from './transcription.utils';

interface PlainTextChatProps {
  transcriptLines: string[];
}

const PlainTextChat = ({ transcriptLines }: PlainTextChatProps) => {
  if (transcriptLines.length === 0) {
    return (
      <Typography variant="bodyLarge" component="p">
        No transcript available. Please wait for the transcript to be generated.
      </Typography>
    );
  }

  if (transcriptLines[0] === NO_TRANSCRIPTION_MESSAGE) {
    return (
      <Typography variant="bodyLarge" component="p">
        {NO_TRANSCRIPTION_MESSAGE}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {transcriptLines.map(line => {
        const { name, time } = getTranscriptionLineTags(line);

        const key = `${name}-${time}`;

        return <Typography key={key}>{line}</Typography>;
      })}
    </Box>
  );
};

export default PlainTextChat;
